import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, flatMap, switchMap } from 'rxjs/operators';
import { CalcTypeService } from '../../lookups/calc-type.service';
import * as fromShared from '../../shared';
import {
    DisplayMessageMinimum,
    IStatusMessage,
    ResponseStatus
} from '../../shared';
import { BudgetUploadService } from '../budget-upload.service';
import * as C_Actions from './budget-upload.actions';
import moment from 'moment';

@Injectable()
export class BudgetUploadEffects {
    constructor(
        private actions$: Actions,
        private service: BudgetUploadService
    ) {}

    uploadBudgets$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(C_Actions.uploadBudgets),
            switchMap(a =>
                this.service.uploadBudgets(a.JsonString).pipe(
                    flatMap(resp => [
                        localStorage.setItem('uploadMessage', resp)
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
}
